module.exports = __webpack_public_path__ + "img/header_4.7c7e626b.jpg";